// Wave 19 — Voice-search FAQs for Notary + Apostille + MFA mega hub.
// 18 Q&A, spoken-form, 25–45 words each, entity-named, factual.
// Non-duplicative with /notary/faq, /moj-translator/faq, /sworn-translator/faq.
import type { VoiceFAQ } from "@/components/seo/VoiceSearchFAQ";

export const NOT_APO_MFA_VOICE_FAQS: VoiceFAQ[] = [
  {
    q: "notary public กับ apostille กับ นิติกรณ์ ต่างกันยังไง",
    a: "Notary รับรองลายเซ็น/สำเนาโดยทนายที่ขึ้นทะเบียนสภาทนายความ · นิติกรณ์คือประทับตรากรมการกงสุลกระทรวงต่างประเทศไทย · Apostille คือรูปแบบมาตรฐาน Hague ที่ 130 ประเทศยอมรับโดยไม่ต้องผ่านสถานทูต NYC ทำได้ครบทั้งสามในสายเดียว",
  },
  {
    q: "what is the difference between notary apostille and mfa legalization",
    a: "Notary attests signatures or copies via a Thai-licensed attorney. MFA legalisation is the Consular Department stamp Thai documents still need today. Apostille is the Hague-standard seal, which enters into force for Thailand on 28 February 2027 (source: HCCH).",
  },
  {
    q: "ประเทศไทยเข้าร่วม hague apostille หรือยัง",
    a: "ไทยยื่นภาคยานุวัติสารเมื่อ 30 มิถุนายน 2569 และอนุสัญญาจะมีผลบังคับใช้กับไทยวันที่ 28 กุมภาพันธ์ 2570 ตามประกาศ HCCH · ก่อนถึงวันนั้นเอกสารไทยยังต้องผ่านกรมการกงสุลและสถานทูตปลายทางตามเดิม",
  },
  {
    q: "apostille ในไทยเริ่มใช้ได้เมื่อไหร่",
    a: "เริ่มใช้ได้ตั้งแต่ 28 กุมภาพันธ์ 2570 เป็นต้นไปตามวันที่อนุสัญญามีผลกับไทย · เอกสารที่ต้องใช้ก่อนหน้านั้นให้เดินสายเดิม คือ ทนาย Notary แล้วรับรองนิติกรณ์กรมการกงสุล แล้วจึงยื่นสถานทูตประเทศปลายทาง",
  },
  {
    q: "รับรองสำเนาพาสปอร์ต ราคาเท่าไหร่",
    a: "ที่ NYC ค่ารับรองสำเนาพาสปอร์ตโดยทนายผู้ทำคำรับรอง (Notary) ฿500/ชุด สำหรับใช้ยื่นสถานทูต บัญชีธนาคารต่างประเทศ หรือขึ้นทะเบียนบริษัทที่ต่างประเทศ · เสร็จภายใน 30 นาทีถ้าเดินเข้าสำนักงาน Lat Phrao 95",
  },
  {
    q: "notary public near bts sukhumvit",
    a: "NYC's Lat Phrao 95 office is a 20-minute taxi from BTS Nana or Asok, at MRT Ratchadaphisek interchange. English-speaking Notarial Services Attorneys walk-in Mon–Sat 09:00–18:00. Free consultation via LINE @nycli.",
  },
  {
    q: "ขอ apostille สำหรับยื่นสมัครเรียนต่ออเมริกา ทำยังไง",
    a: "ยื่นทรานสคริปต์และวุฒิบัตรที่ NYC เราแปลเป็นอังกฤษโดยนักแปล MFA + รับรองลายเซ็นผู้แปลโดยทนาย + ยื่นประทับ Apostille ที่กรมการกงสุลแจ้งวัฒนะให้ครบชุด เริ่ม ฿4,500/ท่าน เสร็จ 5–7 วันทำการ ส่ง DHL ถึงมหาวิทยาลัยปลายทาง",
  },
  {
    q: "affidavit for foreign bank account thailand",
    a: "Foreign banks like HSBC, DBS, and UBS often require a notarized proof-of-residence affidavit. NYC drafts the statement in English, notarizes, and legalizes with MFA or Apostille in three business days from THB 3,500 all-in.",
  },
  {
    q: "รับรองใบรับรองโสดต่างชาติ ยื่นจดทะเบียนสมรสในไทย ต้องทำอะไรบ้าง",
    a: "ให้สถานทูตต้นทางออกใบรับรองโสด ประทับตรา + NYC แปลไทยโดยนักแปล MoJ + ประทับกรมการกงสุล + ยื่นที่ว่าการอำเภอ ครบชุด ฿3,800–5,500 · เสร็จ 3–5 วันทำการ · จองผ่าน LINE @nycli",
  },
  {
    q: "notarize power of attorney for property sale thailand",
    a: "For non-resident owners, NYC drafts a bilingual specific POA, notarizes the signature, legalizes with Thai MFA, and if the buyer is overseas we can add Hague Apostille or Chinese embassy chain-legalization. Full package from THB 4,800.",
  },
  {
    q: "รับรองนิติกรณ์กรมการกงสุลใช้เวลากี่วัน",
    a: "งานปกติ 3–5 วันทำการ · ด่วน 24–48 ชม. เพิ่ม 50% · ค่าธรรมเนียมกรม ฿200 ต่อชุดสำหรับต้นฉบับ, ฿400 สำหรับคำแปล · NYC ยื่นแทนคุณและติดตามหมายเลขคำขอออนไลน์ผ่านระบบ eCS ของกงสุล",
  },
  {
    q: "how long does mfa legalization take in thailand",
    a: "Standard filing at MFA Consular Department in Chaeng Watthana takes 3–5 business days. NYC's 24-48 hour rush costs a 50% surcharge. Official fees are THB 200 per original document and THB 400 per translation.",
  },
  {
    q: "apostille สำหรับเอกสารบริษัทไปตั้งบริษัทที่สิงคโปร์",
    a: "หนังสือรับรองบริษัท ภ.พ.20 และงบการเงินต้องแปลอังกฤษโดย MoJ + Apostille ที่กรมการกงสุลไทย · NYC จัดชุดพร้อมพยานทนายและ Certificate of Translation Accuracy · ราคา ฿6,500 ต่อชุดครบ · เสร็จ 5–7 วันทำการ",
  },
  {
    q: "chinese embassy legalization vs apostille thailand",
    a: "China is not a Hague member for the Chinese mainland, so documents still need MFA + Chinese Embassy Bangkok legalization (Ministry of Foreign Affairs of the PRC office in Bangkok). NYC's chain package is THB 5,800/document, 7–10 business days.",
  },
  {
    q: "เอกสารที่กงสุลตีกลับ ทำยังไงต่อ",
    a: "NYC วิเคราะห์เหตุตีกลับใน 24 ชม. · ปัญหาที่พบบ่อยคือคำแปลชื่อบุคคลไม่ตรงพาสปอร์ต, ตราประทับต้นฉบับไม่ชัด, หรือใช้ผู้แปลนอกทะเบียน MFA · NYC แก้ไขและยื่นซ้ำให้ฟรีถ้าพลาดจากฝ่ายเรา",
  },
  {
    q: "can you notarize documents online in thailand",
    a: "Thailand does not yet recognize remote online notarization (RON). NYC therefore requires in-person signing at Lat Phrao 95 or off-site attendance in Bangkok for a fixed travel fee. We ship notarized originals worldwide via DHL Express.",
  },
  {
    q: "รับรองเอกสารทางการแพทย์ยื่นประกันต่างประเทศ",
    a: "ใบรับรองแพทย์และรายงานการวินิจฉัย NYC แปลอังกฤษ + ทนายรับรองคำแปล + Apostille หรือ MFA ตามที่ประกันปลายทางกำหนด · ราคาเริ่ม ฿3,200/ชุด · เสร็จ 3 วันทำการ · เก็บข้อมูลตาม PDPA ทุกขั้นตอน",
  },
  {
    q: "does nyc offer free document review before legalization",
    a: "Yes. Send scans via LINE @nycli or nycli@ilc.ltd and our attorneys reply within 15 minutes on business hours with a checklist of missing stamps, translation risks, and a fixed quote. Reviews are free with no obligation.",
  },
];
